import React from 'react';
import BarTheme from '../styles/bartheme.js';
import LineTheme from '../styles/linetheme.js';
import PieTheme from '../styles/pietheme.js';
import { VictoryBar, VictoryArea, VictoryLine, VictoryChart, VictoryAxis, VictoryPie, VictoryLabel, VictoryTooltip, VictoryVoronoiContainer, VictoryLegend } from 'victory';

var Graphs = {

	users_by_age : function(data) {
		
		var ageBrackets = {
			tickValues : [1, 2, 3, 4, 5, 6, 7],
			tickFormat : ["18-24", "25-34", "35-44", "45-54", "55-64", "65-74", "75+"]
		};

		if(parseInt(window._fiSponsor.sponsors[0].min_age) !== 18 && typeof window._fiSponsor.sponsors[0].min_age !== 'undefined') {
			var min_age_fmt = window._fiSponsor.sponsors[0].min_age.toString() + "-17";
			ageBrackets = {
				tickValues : [1, 2, 3, 4, 5, 6, 7, 8],
				tickFormat : [ min_age_fmt, "18-24", "25-34", "35-44", "45-54", "55-64", "65-74", "75+"]
			};
		}
		else if(data.length > ageBrackets.tickValues.length) {
			data.shift();

			for(const property in data) {
				data[property]['agerange'] -= 1;
			}
		}

		var finalData = [];

		if(window.app.version.indexOf('demo') > -1) {
			var demoVals = [250, 350, 200, 175, 150, 100, 50]
			for(var i = 0; i != data.length; i++) {
				finalData[i] = data[i];
				finalData[i]['users'] = demoVals[i];
			}
		}
		else {
			finalData = data;
		}

		var maxY = Math.max.apply(Math, finalData.map(function(o) { return o.users; }));
		maxY = Math.ceil((maxY * 1.2) / 5) * 5; //We want the Y axis to have a little padding here so the highest value isn't right at the top.


		//var modulus1 = Math.round((maxY * 0.1 / parseFloat(maxY.toString().substring(0, 1)))).toString();
		//modulus1 = parseFloat((modulus1.substring(0, 1)).padEnd(modulus1.length, "0"));
		//var modulus2 = (modulus1 * 4).toString();

		return (
			<div style={{width: '100%', height: '100%', padding: '0%'}} >
				<svg style={{display: 'inline-block', float: 'left', top: '0px', height: '0px'}}>
					<defs>
						<filter id="shadow">
			      			<feDropShadow dx="2" dy="2" stdDeviation="1.5"/>
			    		</filter>
			    	</defs>
			    </svg>
		  <VictoryChart
		    // domainPadding will add space to each side of VictoryBar to
		    // prevent it from overlapping the axis
		    theme={BarTheme('cyan')}
		    domainPadding={30}
		    maxDomain={{y: parseInt(maxY)}}
		  >
		    <VictoryBar 
		      data={finalData}
		      x="agerange"
		      y="users"
		      labels={({ datum }) => `Users: ${datum._y}`}
  			  labelComponent={
  			  	<VictoryTooltip 
  			  	constrainToVisibleArea
  			  	dy={0} 
  			  	centerOffset={{ x: 0 }} 
  			  	flyoutHeight={35} 
  			  	pointerWidth={0} 
  			  	flyoutStyle={{ stroke: 'transparent', fill: '#FFFFFF', filter: "url(#shadow)"}}  />}
		    />
		    <VictoryAxis
		      // tickValues specifies both the number of ticks and where
		      // they are placed on the axis
		      tickValues={ageBrackets.tickValues}
		      tickFormat={ageBrackets.tickFormat}
		      style={{ ticks: {stroke: "none", size: 0}, tickLabels: {fontSize: 12} }}
		    />
		    <VictoryAxis
		      dependentAxis
		      // tickFormat specifies how ticks should be displayed
		      tickFormat={(x, index) => (index % 2 !== 0) ? '' : (`${x}`)}
		      tickCount={10}
		      style={{ axis: {stroke: "none"} }}
		    />
		  </VictoryChart>
		  </div>
		);
	},

	cumulative_deposits : function(data) {
		var maxY = Math.max.apply(Math, data.map(function(o) { return parseFloat(o.deposits); }));
		maxY = Math.ceil((maxY * 1.2) / 5) * 5; //We want the Y axis to have a little padding here so the highest value isn't right at the top.

		var determineQuarter = function(dateStr) {
			var d = new Date(dateStr);
			var m = Math.floor(d.getMonth() / 3) + 1;
			m -= m > 4 ? 4 : 0;
			var y = d.getFullYear();

			var returnStr = y.toString() + " Q" + m.toString();
			//console.log(returnStr);
			//console.log(dateStr);
			return returnStr;
		};

		var xTick1 = (data[1].date) ? determineQuarter(data[1].date) : "0000 Q1",
			xTick2 = (data[4].date) ? determineQuarter(data[4].date) : "0000 Q2",
			xTick3 = (data[7].date) ? determineQuarter(data[7].date) : "0000 Q3",
			xTick4 = (data[10].date) ? determineQuarter(data[10].date) : "0000 Q4";

		return (
			<div style={{width: '100%', height: '100%', padding: '0%'}} >
				<svg style={{display: 'inline-block', float: 'left', top: '0px', height: '0px'}}>
					<defs>
						<filter id="shadow">
			      			<feDropShadow dx="2" dy="2" stdDeviation="1.5"/>
			    		</filter>
			    	</defs>
			    </svg>
		  <VictoryChart
		    // domainPadding will add space to each side of VictoryBar to
		    // prevent it from overlapping the axis
		    theme={LineTheme()}
		    domainPadding={40}
		    maxDomain={{y: parseInt(maxY)}}
		    containerComponent={
			    <VictoryVoronoiContainer
			      //mouseFollowTooltips
			      labels={({ datum }) => {
			      	if(datum.childName === 'chart-area-0') 
			      		return `${datum.date + '\n$' + parseFloat(datum._y).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
			      }}
			      labelComponent={
			      	<VictoryTooltip
			      		constrainToVisibleArea 
			      		flyoutHeight={35} 
			      		pointerWidth={0} 
			      		flyoutStyle={{ stroke: 'transparent', fill: '#FFFFFF', filter: "url(#shadow)" }}
			      	/>
			      }
			    />
			  }
		  >
		    <VictoryArea
		      data={data}
		      x="time"
		      y="deposits"/>
		    <VictoryLine
		      data={data}
		      x="time"
		      y="deposits"
		    />
		    <VictoryAxis
		      // tickValues specifies both the number of ticks and where
		      // they are placed on the axis
		      tickValues={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
		      tickFormat={["", xTick1, "", "", xTick2, "", "", xTick3, "", "", xTick4]} //These values will be generated once we have real data
 		      style={{ ticks: {stroke: "none", size: 0}, tickLabels: {fontSize: 15} }}
		    />
		    <VictoryAxis
		      dependentAxis
		      // tickFormat specifies how ticks should be displayed
		      tickFormat={(x, index) => (index % 2 !== 0) ? '' : (x >= 1000 && x < 10000) ? (`${"$" + x.toString().slice(0, -3) + '.' + x.toString().slice(1, 2) +  'k'}`) : (x >= 10000 && x < 999999) ? "$" + x.toString().slice(0, -3) + "." + x.toString().slice(-3, -2) + "k" : (x >= 1000000) ? '$' + x.toString().slice(0, -6) + "." + x.toString().slice(-6, -5) + 'm' : (`${'$' + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`)}
		      tickCount={10}
		      style={{ axis: {stroke: "none" } }}
		    />
		  </VictoryChart>
		  </div>
		);
	},

	completed_goals : function(data) {
		var quartersBrackets = {
			tickValues : [1, 2, 3, 4],
			tickFormat : data.map(function (o) { return o.quarter; })
		};

		var finalData = data;

		var maxY = Math.max.apply(Math, finalData.map(function(o) { return o.goals_completed; }));
		maxY = Math.ceil((maxY * 1.2) / 5) * 5; //We want the Y axis to have a little padding here so the highest value isn't right at the top.

		return (
			<div style={{width: '100%', height: '100%', padding: '0%'}} >
				<svg style={{display: 'inline-block', float: 'left', top: '0px', height: '0px'}}>
					<defs>
						<filter id="shadow">
			      			<feDropShadow dx="2" dy="2" stdDeviation="1.5"/>
			    		</filter>
			    	</defs>
			    </svg>
		  <VictoryChart
		    // domainPadding will add space to each side of VictoryBar to
		    // prevent it from overlapping the axis
		    theme={BarTheme('lime')}
		    domainPadding={30}
		    maxDomain={{y: parseInt(maxY)}}
		  >
		    <VictoryBar 
		      data={finalData}
		      x="time"
		      y="goals_completed"
		      labels={({ datum }) => `Goals: ${datum._y}`}
  			  labelComponent={
  			  	<VictoryTooltip 
  			  	constrainToVisibleArea
  			  	dy={0} 
  			  	centerOffset={{ x: 0 }} 
  			  	flyoutHeight={35} 
  			  	pointerWidth={0} 
  			  	flyoutStyle={{ stroke: 'transparent', fill: '#FFFFFF', filter: "url(#shadow)"}}  />}
		    />
		    <VictoryAxis
		      // tickValues specifies both the number of ticks and where
		      // they are placed on the axis
		      tickValues={quartersBrackets.tickValues}
		      tickFormat={quartersBrackets.tickFormat}
		      style={{ ticks: {stroke: "none", size: 0}, tickLabels: {fontSize: 12} }}
		    />
		    <VictoryAxis
		      dependentAxis
		      // tickFormat specifies how ticks should be displayed
		      tickFormat={(x, index) => (index % 2 !== 0) ? '' : (`${x}`)}
		      tickCount={10}
		      style={{ axis: {stroke: "none"} }}
		    />
		  </VictoryChart>
		  </div>
		);
	},

	fi_users_pie : function(data, additionalLabelText) {
		const cyanColors = [
	  			'rgb(41, 171, 226)',
	  			'#6bd4ff',
	  			'#38caff',
	  			'rgb(22, 135, 200)'
	  		];
	  	const greenColors = [
	  			'rgb(142, 198, 64)',
	  			'#9bbf6b',
	  			'#8eb856',
	  			'rgb(100, 160, 67)'
	  		];

	  	if (window._fiSponsor.sponsors[0].name === 'West Community Credit Union' || window._fiSponsor.sponsors[0].name === 'Tigers Credit Union') {
			data[0].x = 'Current\nMembers';
			data[1].x = 'Non\nMembers';
		}

		var pieChart = (
			<div style={{width: '100%', height: '100%', padding: '0%'}} >
				<svg style={{display: 'inline-block', float: 'left', top: '0px', height: '0px'}}>
					<defs>
			            <linearGradient id='gradientCyan'
			              x1='0%'
			              x2='0%'
			              y1='0%'
			              y2='100%'
			            >
			            <stop offset='0%'  stopColor={cyanColors[0]} />
			            <stop offset='100%' stopColor={cyanColors[3]}  />
			            </linearGradient>
			            <linearGradient id='gradientGreen'
			              x1='0%'
			              x2='0%'
			              y1='0%'
			              y2='100%'
			            >
			              <stop offset='0%'  stopColor={greenColors[0]} />
			              <stop offset='100%' stopColor={greenColors[3]} />
			            </linearGradient>
			        </defs>
		        </svg>
		        <svg viewBox="0 0 100 85">
		        <VictoryLegend
		        	x={8}
		        	y={69}
		        	theme={PieTheme()}
		        	standalone={false}
		        	orientation="horizontal"
		        	gutter={2}
					style={{ border: { stroke: "transparent" } }}
					colorScale={[ "url(#gradientCyan)", "url(#gradientGreen)" ]}
					data={[
					{ name: data[1].x.replace('\n', ' ') }, { name: data[0].x.replace('\n', ' ') }
					]}

		        />
				<VictoryPie
					theme={PieTheme()}
					standalone={false}
					domainPadding={20}
					colorScale={[
						"url(#gradientGreen)",
						"url(#gradientCyan)"
					]}
					style={{
						labels: { 
							fill: "transparent",//"#FFFFFF",//"#55565a",
							fontSize: 0.0,
							fontWeight: 900,
							textShadow: '0.5px 0.5px 0.8px #000000',
							textAnchor: "middle", 
	  					}
	  				}}
					//labelRadius={24}
					innerRadius={20}
					startAngle={65}
					endAngle={425}
					data={data}
				 />
				 </svg>
			</div>
		);

		if(additionalLabelText) {
			pieChart = (
			<div style={{width: '100%', height: '100%', padding: '0%'}} >
				<svg style={{display: 'inline-block', float: 'left', top: '0px', height: '0px'}}>
					<defs>
			            <linearGradient id='gradientCyan'
			              x1='0%'
			              x2='0%'
			              y1='0%'
			              y2='100%'
			            >
			            <stop offset='0%'  stopColor={cyanColors[0]} />
			            <stop offset='100%' stopColor={cyanColors[3]}  />
			            </linearGradient>
			            <linearGradient id='gradientGreen'
			              x1='0%'
			              x2='0%'
			              y1='0%'
			              y2='100%'
			            >
			              <stop offset='0%'  stopColor={greenColors[0]} />
			              <stop offset='100%' stopColor={greenColors[3]} />
			            </linearGradient>
			        </defs>
		        </svg>
				<svg viewBox="0 0 100 85">
					<VictoryLegend
			        	x={18}
			        	y={69}
			        	theme={PieTheme()}
			        	standalone={false}
			        	orientation="horizontal"
			        	gutter={21}
						style={{ border: { stroke: "transparent" }, labels: { fontSize: 2.2 } }}
						colorScale={[ "url(#gradientCyan)", "url(#gradientGreen)" ]}
						data={[{ name: data[1].x.replace('\n', ' '), symbol: { size: 2 } }, { name: data[0].x.replace('\n', ' '), symbol: {size : 2} }
						]}

			        />
					<VictoryPie
						theme={PieTheme()}
						domainPadding={20}
						standalone={false}
						colorScale={[
							"url(#gradientGreen)",
							"url(#gradientCyan)"
						]}
						style={{
							colorScale : [
								'url(#gradientCyan)',
								'url(#gradientGreen)'
							],
							labels: { 
								fill: "transparent",//"#55565a", //"#dedede",//
								fontSize: 0.0, 
								fontWeight: 500,
								textShadow: '0.5px 0.5px 0.8px #FFFFFF',
								textAnchor: "middle"
		  					}
		  				}}
						labelRadius={25}
						innerRadius={20}
						startAngle={65}
						endAngle={425}
						data={data}
					/>
					<VictoryLabel
			          textAnchor="middle"
			          style={{ fill: "#55565A", fontSize: 3}}
			          x={50} y={34.5}
			          text={additionalLabelText}
	        		/>
        		</svg>
        	</div>
			);
		}

		return pieChart;
	
	},

	user_growth_chart : function(data) {
		var maxY = Math.max.apply(Math, data.map(function(o) { return parseFloat(o.users); }));
		maxY = Math.ceil((maxY * 1.2) / 5) * 5; //We want the Y axis to have a little padding here so the highest value isn't right at the top.

		var determineQuarter = function(dateStr) {
			var d = new Date(dateStr);
			var m = Math.floor(d.getMonth() / 3) + 1;
			m -= m > 4 ? 4 : 0;
			var y = d.getFullYear();

			var returnStr = y.toString() + " Q" + m.toString();
			//console.log(returnStr);
			//console.log(dateStr);
			return returnStr;
		};

		var xTick1 = (data[1].date) ? determineQuarter(data[1].date) : "0000 Q1",
			xTick2 = (data[4].date) ? determineQuarter(data[4].date) : "0000 Q2",
			xTick3 = (data[7].date) ? determineQuarter(data[7].date) : "0000 Q3",
			xTick4 = (data[10].date) ? determineQuarter(data[10].date) : "0000 Q4";

		return (
			<div style={{width: '100%', height: '100%', padding: '0%'}} >
				<svg style={{display: 'inline-block', float: 'left', top: '0px', height: '0px'}}>
					<defs>
						<filter id="shadow">
			      			<feDropShadow dx="2" dy="2" stdDeviation="1.5"/>
			    		</filter>
			    	</defs>
			    </svg>
		  <VictoryChart
		    // domainPadding will add space to each side of VictoryBar to
		    // prevent it from overlapping the axis
		    theme={LineTheme()}
		    domainPadding={40}
		    maxDomain={{y: parseInt(maxY)}}
		    containerComponent={
			    <VictoryVoronoiContainer
			      //mouseFollowTooltips
			      labels={({ datum }) => {
			      	if(datum.childName === 'chart-area-0') 
			      		return `Users: ${Math.round(datum._y, 2)}`;
			      }}
			      labelComponent={
			      	<VictoryTooltip 
			      		flyoutHeight={35} 
			      		pointerWidth={0} 
			      		constrainToVisibleArea 
			      		flyoutStyle={{ stroke: 'transparent', fill: '#FFFFFF', filter: "url(#shadow)" }}
			      	/>
			      }
			    />
			  }
		  >
		    <VictoryArea
		      data={data}
		      x="time"
		      y="users"
		      style={{data: {fill: '#70C6EE'} }}
		      />
		    <VictoryLine
		      data={data}
		      x="time"
		      y="users"
		    />
		    <VictoryAxis
		      // tickValues specifies both the number of ticks and where
		      // they are placed on the axis
		      tickValues={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
		      tickFormat={["", xTick1, "", "", xTick2, "", "", xTick3, "", "", xTick4]} //These values will be generated once we have real data
 		      style={{ ticks: {stroke: "none", size: 0}, tickLabels: {fontSize: 15} }}
		    />
		    <VictoryAxis
		      dependentAxis
		      // tickFormat specifies how ticks should be displayed
		      tickFormat={(x, index) => (index % 2 !== 0) ? '' : (x >= 1000 && x < 10000) ? (`${x.toString().slice(0, -3) + '.' + x.toString().slice(-3, -2) + 'k'}`) : (x >= 10000 && x < 999999) ? x.toString().slice(0, -3) + "." + x.toString().slice(-3, -2) + "k" : (x >= 1000000) ? x.toString().slice(0, -6) + "." + x.toString().slice(-6, -5) + 'm' : (`${x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`)}
		      tickCount={10}
		      style={{ axis: {stroke: "none" } }}
		    />
		  </VictoryChart>
		  </div>
		);
	}
}

export default Graphs;